import { z } from "zod";
import {
  defaultTriggerNodeValues,
  triggerNodeSchema,
} from "./triggerNode.schema";
import { collectNodeSchema } from "./collect-node";
import { branchNodeSchema } from "./branch-node";
import { messageNodeSchema } from "./message-node";
import { defaultStartNodeValues, startNodeSchema } from "./startNode";
import { emailActionNodeSchema } from "./action-node/emailActionNode.schema";
import { httpActionNodeSchema } from "./action-node/httpActionNode.schema";
import { optInActionSchema } from "./action-node/optInActionNode.schema";
import { collectFormNodeSchema } from "./collect-form-node";

export const rootNodeSchema = z.object({
  info: z.object({
    flowId: z.string(),
    projectId: z.string(),
    publishToAI: z.boolean().default(false),
  }),
  startNode: startNodeSchema,
  triggerNode: triggerNodeSchema,
  collectNodes: z.array(collectNodeSchema),
  collectFormNodes: z.array(collectFormNodeSchema),
  collectNodeReplay: z.boolean().default(false).optional(),
  collectFormNodeReplay: z.boolean().default(false).optional(),
  branchNodes: z.array(branchNodeSchema),
  messageNodes: z.array(messageNodeSchema),
  messageNodeSmartRephrase: z.boolean().default(false).optional(),
  emailActionNodes: z.array(emailActionNodeSchema),
  httpActionNodes: z.array(httpActionNodeSchema),
  optInActionNodes: z.array(optInActionSchema),
});

export type RootNodeSchema = z.infer<typeof rootNodeSchema>;

export const defaultRootNodeValues: RootNodeSchema = {
  info: {
    flowId: "",
    projectId: "",
    publishToAI: false,
  },
  collectFormNodes: [],
  startNode: defaultStartNodeValues,
  triggerNode: defaultTriggerNodeValues,
  collectNodes: [],
  collectNodeReplay: false,
  branchNodes: [],
  messageNodes: [],
  messageNodeSmartRephrase: false,
  emailActionNodes: [],
  httpActionNodes: [],
  optInActionNodes: [],
};
